import { useEffect, useRef, useState } from 'react';
import { animate } from 'framer-motion';

/**
 * 숫자 카운트업.
 * 0(또는 from)에서 to까지 duration 초 동안 ease-out으로 증가.
 * 값이 바뀔 때마다 재카운트.
 *
 * @param to 최종 값
 * @param duration 초 (기본 0.6)
 * @param format 표시 변환 함수 (기본 toLocaleString)
 * @param prefix/suffix 좌우 부착
 * @param decimals 소수점 자리수 (toFixed)
 */
export default function CountUp({
  to, duration = 0.6, format, prefix = '', suffix = '', decimals = 0,
}: {
  to: number;
  duration?: number;
  format?: (n: number) => string;
  prefix?: string;
  suffix?: string;
  decimals?: number;
}) {
  const [display, setDisplay] = useState<string>(() =>
    (format ?? defaultFormat(decimals))(to)
  );
  const prevRef = useRef<number>(0);

  useEffect(() => {
    const from = prevRef.current;
    const fmt = format ?? defaultFormat(decimals);
    const controls = animate(from, to, {
      duration,
      ease: [0.22, 0.61, 0.36, 1],
      onUpdate: (v) => setDisplay(fmt(v)),
    });
    prevRef.current = to;
    return () => controls.stop();
  }, [to, duration, format, decimals]);

  return <>{prefix}{display}{suffix}</>;
}

function defaultFormat(decimals: number) {
  return (n: number) => Number(n).toLocaleString('ko-KR', {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  });
}
